<template>
  <div class="clearfix main_center"  v-loading.fullscreen.lock="loading">
    <div class="top-content busWinessLeft">
      <div class="left-navbar">
        <el-button @click="back()" size="small">返回</el-button>
      </div>
    </div>
    <div class="right-content clearfix busWinessRight">
      <el-card shadow="never" class="box-card">
        <div class="monitor-video">
          <div class="monitor-video-list">
            <videoPlayer :videoUrl.sync="videoUrl"
                         videoCode="mp4"
                         ref="videoPlayerRef"
                         :isShowControls="true"
                         :keyIframeOffset.sync="keyIframeOffset"
                         :ifisShowControl="true"
                         @switchCurrentVideo="switchVideoUrl">
            </videoPlayer>
          </div>
          <placeAndEquipment
                  ref="placeAndEquipmentRef"
                  :roomType="openBidWitness_dataTypeObj.bidEvaluation"
                  abTop="180px"
                  abRight="62px"
                  :currentVideo.sync="currentVideo"
                  :videoSwitchData.sync="videoSrcData"
                  @switchCurrentVideo="switchVideoUrl"></placeAndEquipment>
        </div>
      </el-card>
      <!--form-->
      <el-form ref="form" :model="form" label-width="138px" style="margin-top:12px;padding:0px 24px" class="form">
          <el-row :gutter="15">
            <el-col :span="6">
              <el-form-item label="抽取颗粒度：" prop='dataGroup' >
                <span>{{form.dataGroup=="1"?'关联项目':form.dataGroup=="2"?'关联标段':'标段组合'}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="form.dataGroup==1?'关联项目：':form.dataGroup=='2'?'关联标段：':'标段组合：'" prop='releProjectName'  style="width: calc(100% - 100px);display: inline-block">
                <span v-if="form.dataGroup=='1' || form.dataGroup=='2'">{{displayName}}</span>
                <p v-else>
                  <el-tag :key="index" size="small" type="info" v-for="(item,index) in form.bidList">{{item.bidSectionName}}</el-tag>
                </p>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="监督记录：" prop='remark' >
                <el-input type="textarea" disabled :rows="3" v-model="form.remark" ></el-input>
              </el-form-item>
            </el-col>
          </el-row>


          <el-row>
            <el-col :span="12">
              <el-form-item label="监督人：" prop='superviseMan' >
                <el-input  disabled  v-model="form.superviseManName" ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-form-item label="记录关键帧："  >

                <el-table
                        :data="tableDataDetail.slice((pageIndex-1)*pageSize,pageIndex*pageSize)"
                        border
                        stripe
                        v-loading="keyListLoading"
                        style="width: 100%">
                  <el-table-column
                          header-align="center"
                          label="序号"
                          width="50"
                          type="index"
                          align="center">
                  </el-table-column>
                  <el-table-column
                          header-align="center"
                          label="操作"
                          width="80"
                          align="center">
                    <template slot-scope="scope">
                      <el-button @click="confirmPosition(scope.row.timeDeviationSec,scope.$index)" type="text"  size="small">定位</el-button>
                    </template>
                  </el-table-column>
                  <el-table-column
                          prop="recordTime"
                          header-align="center"
                          label="时间"
                          width="180"
                          align="center">
                    <template  slot-scope="scope">
                      <span style="margin-left: 10px" >{{scope.row.recordTimeStr}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="快照" align="center" width='100'>
                    <template slot-scope="scope">
                      <img :src="scope.row.screenshotUrl" @click="showImgDialog(scope.row.screenshotUrl)" v-if="scope.row.screenshotUrl" class="thumbnail" alt="">
                    </template>
                  </el-table-column>
                  <el-table-column
                          prop="remark"
                          header-align="center"
                          :show-overflow-tooltip="true"
                          label="备注">
                  </el-table-column>
                </el-table>
                <el-pagination
                        @size-change="sizeChangeHandle"
                        @current-change="currentChangeHandle"
                        hide-on-single-page
                        :current-page="pageIndex"
                        :page-sizes="[10, 20, 50, 100]"
                        :page-size="pageSize"
                        :total="total"
                        layout="total, sizes, prev, pager, next, jumper"
                >
                </el-pagination>

              </el-form-item>
            </el-col>
          </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="监督记录提交时间：">
              <el-input  disabled  v-model="form.updateTime" ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        </el-form>
    </div>


    <el-dialog :visible.sync="imgDialogVisible" width="100%" height="100%" @closed="dialogClose">
      <img :src="dialogImageUrl" alt="" @contextmenu.prevent=""  class="viewImg">
    </el-dialog>

  </div>





</template>

<script>
  import videoPlayer from "@/components/videoPlayer/video";
  import placeAndEquipment from "@/components/videoPlayer/placeAndEquipment";
  // import {tabsCloseCurrentHandle} from '@/utils/routeTab';
  import {getExpertWitnessRecordById} from '@/server/bidOpenEvalWitness';
  import {getFieldsAndDevicePlayback} from '@/server/field';
  import {scrollToTop} from '@/utils/index';

  export default {
  components: {
    videoPlayer,
    placeAndEquipment
  },
  data(){
    return{
      loading:false,
      imgDialogVisible:false,
      dialogImageUrl:"",
      isIE:false,
      currentVideo:{},
      pageIndex:1,
      pageSize:10,
      total:0,
      videoSrcData:[],
      videoHeight:750,
      keyIframeOffset:[],
      // videoUrl:"rtmp://58.200.131.2:1935/livetv/cctv1",
      videoUrl:[
        // {
        //   url:"rtmp://58.200.131.2:1935/livetv/cctv1",
        //   leavel: "高清"
        // }
      ],

      dateRange:[],//交易时间范围
      displayName:'',//页面展示的项目名称或标段名称
      form:{    //见证数据
        id: "",          //见证数据ID
        bidopenTime: "", //开标时间
        businessId: "",  //关联的项目ID
        businessexId: "",//关联的标段ID
        createTime: "",  //创建时间
        createUser: "",  //创建人
        dataGroup: "",   //是否关联项目  1:关联项目  2:关联标段
        dataType: "",    //见证类型     1专家抽取见证 2开标见证 3评标见证
        delFlag: false,
        detailList: [], //见证明细数据
        evalEtime: "",  //评标开始时间
        evalStime: "",  //评标结束时间
        field1: "",
        field2: "",
        field3: "",
        fileTypeDictCode: "",
        fileTypeMap: {},
        historyid: "",  //-1:暂存   0:已生效
        remark: "",     //备注
        updateTime: "", //更新时间
        updateUser: "", //更新用户
        videoEtime: "", //视频结束时间
        videoStime: "", //视频开始时间
        superviseMan: "",
        superviseManName:"",
        project: {  //项目数据
          id: "",
          projectCode: "",   //项目编号
          projectName: "",   //项目名称
          tenderAgencyName: "", //招标代理机构名称
          tendererName:""   //招标人名称
        },
        bid:{ //标段数据
          id:'',
          bidCode: '',
          bidName:''
        },
      },
      tableDataDetail: [],
      keyListLoading:false,
    }


  },
  mounted() {
    this.videoHeight = document.documentElement.clientHeight<600?600:(document.documentElement.clientHeight-125);
  },
  computed:{

  },
  activated(){

    this.form.id = (this.$route.query && this.$route.query.id ) || '' ;
    this.form.businessType = (this.$route.query && this.$route.query.businessType ) || '';
    this.getDataById();

    this.$nextTick(() => {
      if(this.$refs.videoPlayerRef){
        this.$refs.videoPlayerRef.play(); // 播放
      }
    })



  },
  deactivated() {
    if(this.$refs.videoPlayerRef){
      this.$refs.videoPlayerRef.pause();  // 暂停
    }
  },
  methods:{
    back(){
      tabsCloseCurrentHandle();
      this.$router.go(-1)
    },
    //定位视频
    confirmPosition(timeDeviationSec) {
      if(this.$refs.videoPlayerRef){
        this.$refs.videoPlayerRef.setCurrentTime(timeDeviationSec);
      }
      scrollToTop()

    },



    dialogClose() {
      this.dialogImageUrl = "";
      this.imgDialogVisible = false;
    },
    // 图片放大弹窗
    showImgDialog(filePath){
      this.dialogImageUrl=filePath;
      this.imgDialogVisible = true;
    },

    switchVideoUrl(video){

      video.playUrl = video.playUrl?video.playUrl:'';
      video.leavel = video.deviceName || '';
      this.currentVideo = video;
      if(!this.currentVideo.playUrl){
        this.$message({
          type: 'error',
          message: '视频正在合成，请稍后刷新播放'
        })
      }
      this.videoUrl = this.currentVideo.playUrl?[this.currentVideo]:[];
      this.getKeyIframeList();


    },
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1
      this.getDataList()
    },
    currentChangeHandle (val) {
      this.pageIndex = val
      this.getDataList()
    },
    getKeyIframeList() { // 获取列表数据

      if(this.form.id && this.currentVideo.deviceCode){
        this.keyListLoading = true;
        this.$httpReq.get(`/trading/tradingWitDetails/getByWitnessIdAndDeviceCode?parentId=${this.form.id}&deviceCode=${this.currentVideo.deviceCode}&timeDeviation=${this.currentVideo.timeDeviation || 0}`,)
          .then(res=>{
            this.keyListLoading = false;
            if(res.data.code =="1"){
              this.tableDataDetail = res.data.data;
              this.pageIndex = 1;
              this.pageSize = 10;
              this.total = this.tableDataDetail.length;
              const that = this;
              var timeOffSetArr = []
              this.tableDataDetail.forEach((item)=>{
                var timeDeviationSec = parseInt( (new Date(item.recordTime.replace(/-/g,"/")).getTime() - new Date(item.videoStime.replace(/-/g,"/")).getTime() )/1000 ) + (item.timeOffset?parseInt(item.timeOffset):0) ;
                if(timeDeviationSec >0){
                  item.timeDeviationSec = timeDeviationSec || 0;
                  timeOffSetArr.push(timeDeviationSec);
                  item.recordTimeStr=that.formatterTimeDeviation(timeDeviationSec);
                }else{
                  item.recordTimeStr = '-:-:-'
                }
              })
              this.keyIframeOffset = timeOffSetArr;
            }else{
              this.tableDataDetail = [];
            }

          })
      }

    },

    formatterTimeDeviation(timeDeviationSec){

      var hours = parseInt(timeDeviationSec  / 60 / 60 % 24 , 10);
      var minutes = parseInt(timeDeviationSec  / 60 % 60, 10);
      var seconds = parseInt(timeDeviationSec  % 60, 10);
      return (hours<10?('0'+hours):hours) + ":"+ (minutes<10?('0'+minutes):minutes) +':'+ (seconds<10?('0'+seconds):seconds);

    },

    backBtn(){ //返回
      tabsCloseCurrentHandle();
      this.clearData()
      // this.$router.push({
      //   name:'expertWitness_list'
      // })
      this.$router.go(-1)

    },

    getDataById(){ //详情
      if(this.form.id){
        getExpertWitnessRecordById(this.form.id).then((res)=>{
          const {data}=res;
          if(data.code=='1'){
            this.form = {...data.data};
            this.form.dataGroup = this.form.dataGroup.toString();
            // this.displayName = this.form.dataGroup == 1? data.data.tenderProjectName:data.data.bidSectionName;
            this.displayName = this.form.dataGroup == '1'? data.data.tenderProjectCode:data.data.bidSectionCode;
            this.$refs.placeAndEquipmentRef.getFieldsAndDevicePlaybackFn({
              code:this.form.dataGroup != '1'?this.form.bidCode:this.form.tenderProjectCode,
              roomType: this.openBidWitness_dataTypeObj.expertExtraction,// 8:专家抽取室  1:开标室 2:评标室
              bizType:this.form.dataGroup != '1'?'bid':"project",// 业务分组 bid 或者 project
              deviceType:'', // 1桌面  2 摄像头
              tradeOrgId:'' // 交易中心id
            })

          }
        })
      }else{
        // this.$router.push({
        //   name:'openBidAndEstimateWitness_beginList'
        // })
      }
    },


  },

}
</script>

<style lang="scss" scoped>

  .monitor-video{
    width:100%;
    padding:24px;
    background: #001F39;
    border-radius: 2px;
    display: inline-block;
    box-sizing: border-box;
    position: relative;
    .monitor-video-list{
      position: relative;
      display: inline-block;
      width:calc(70% - 16px);
      height: 682px;
      margin-right:16px
    }
    .screenshot{
      position:absolute;
      top: 44%;
      right: 48px;
      width: 80px;
      height: 80px;
      border-radius: 50%;
      background: rgba(0, 0, 0, 0.25);
      text-align: center;
      padding-top:14px;
      cursor: pointer;
      color: rgba(255, 255, 255, 0.65);
      padding:0;
      .sereen-text{
        display:block ;
        font-size: 16px;
      }
    }
    .screenshot:hover{
      background: rgba(0, 0, 0, 0.65);
      color: #fff;
    }
    .screenshot-ie{
      position:absolute;
      bottom: -6%;
      right: 0;
      width: 75px;
      height: 32px;
      line-height: 32px;
      background: rgba(255, 255, 255, 0.15);
      border-radius: 2px;
      text-align: center;
      // padding-top:14px;
      cursor: pointer;
      color: rgba(255, 255, 255, 0.65);
      padding:0;
      .screen-img{
        vertical-align:text-bottom;
      }
      .sereen-text{
        font-size: 16px;
      }
    }
    .screenshot-ie:hover{
      background: rgba(0, 0, 0, 0.65);
      color: #fff;
    }
  }
  .monitor-video-ie{
    height:770px
  }

  .open-bid-detail-form{
    margin:20px;
    .btn{
      text-align: center;
    }
  }


  .viewImg{
    height: 100%;
    display: block;
    margin: 0 auto;
  }

  .main_center{

    /deep/ .el-dialog__header{
      border-bottom: 0;
    }
    /deep/ .el-dialog__body{
      padding: 0 10px 20px 10px;
    }




  }


  .thumbnail{
    width: 50px;
    height: 50px;
  }
</style>